import { CustomerPaymentActionsComponent } from './customer-payment.actions.component';

export function CustomerPaymentsCtrl (
  $scope,
  $state,
  $translate,
  customerPaymentApi,
  tableApi,
  workshopAPI
) {

  $scope.showCustomerPayments = !!$scope.payments.length;
  $scope.tableCacheKey        = 'customerPayments';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'customer_payment_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.PAYMENT_NUMBER')
        }
      },
      {
        field : 'reference',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-right',
        field  : 'applied_amount',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.APPLIED_AMOUNT')
        },
        pipe: 'globalCurrency',
      },
      {
        classes: 'text-right',
        field  : 'amount',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onViewMethodsClick: payment => $scope.viewPaymentMethods(payment),
              onEditClick       : payment => $state.go('app.customer-payment', {
                customer_id: payment.customer_id,
                id         : payment.id
              })
            }
          },
          enabled: !$scope.customer.archived,
          factory: CustomerPaymentActionsComponent,
        },
        sortable: false
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/payment_count/' + $scope.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'post_date'
    }),
  };

  $scope.getPayments = ( params ) => {
    return workshopAPI.get('/customers/payment_list', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(payments => {
      $scope.payments = payments;

      return payments;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if ( !$scope.customer.archived ) {
      $state.go('app.customer-payment', {
        customer_id: $scope.customer.id,
        id         : event.row.id
      });
    }
  };

  $scope.viewPaymentMethods = function (row) {
    customerPaymentApi.getPayment(row.id)
    .then(payment => customerPaymentApi.viewPaymentMethods(payment));
  };
}
